angular.module('impactx.imagezoom').directive('ixImageZoom', function () {
    return {
        restrict: 'E',
        templateUrl: 'shared/imagezoom/templates/image-zoom.html',
        controller: 'ImageZoomCtrl',
        controllerAs: '$ctrl',
        bindToController: {
            imageUrl: '=',
            zoomFactor: '='
        },
        replace: true
    }
});